import { render, staticRenderFns } from "./TireListRecommendationSidebar.vue?vue&type=template&id=ea98bd00"
import script from "./TireListRecommendationSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./TireListRecommendationSidebar.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports